<template>
    <!-- 编辑界面 -->
    <el-drawer :title="title" :visible.sync="editFormVisible" @click="closeDialog" :size="600" :wrapperClosable="false"
        :modal="false" :destroy-on-close="true" class="margin_top_40">
        <el-form label-width="8.75rem" :model="editForm" ref="editForm" :rules="rules">
            <el-form-item label="所属门店" prop="storeKeyId">
                <el-select v-model="editForm.storeKeyId" placeholder="请选择门店" clearable size="small" class="input_200px"
                    @change="handleChangeStore" :disabled="editForm.isConfirm == true">
                    <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                        :key="item.keyId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="下拨金额(元)" prop="money">
                <el-input-number v-model.number="editForm.money" placeholder="请输入下拨金额(元)" :min="0" :precision="2" :step="0.01" clearable size="small"
                    class="input_200px" :disabled="editForm.isConfirm == true"></el-input-number>
            </el-form-item>
            <el-form-item label="收款员工：" prop="employeeKeyId">
                <el-select v-model="editForm.employeeKeyId" placeholder="请选择员工" clearable filterable size="small"
                    class="input_200px" :disabled="editForm.isConfirm == true">
                    <el-option v-for="item in userList" :label="item.value" :value="item.keyId"
                        :key="item.keyId"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div class="drawer-footer">
            <el-button
                v-if="this.$checkBtnPermission('/storeCost/appropriation', 'create') && editForm.isConfirm == false"
                size="small" icon="el-icon-check" :loading="loading" class="title" @click="submitForm('editForm')">
                保存
            </el-button>
            <el-button size="small" icon="el-icon-delete" :loading="loading" class="title" type="danger"
                v-if="editForm.keyId != '' && this.$checkBtnPermission('/storeCost/appropriation', 'delete') && editForm.isConfirm == false"
                @click="deleteForm('editForm')">
                删除
            </el-button>
            <el-button size="small" icon="el-icon-finished" :loading="loading" class="title" type="success"
                v-if="editForm.keyId != '' && this.$checkBtnPermission('/storeCost/appropriation', 'confirm') && editForm.isConfirm == false"
                @click="confirmForm('editForm')">
                确认下拨
            </el-button>
        </div>
    </el-drawer>
</template>

<script>
import {
    SaveStoreAppropriation,
    DeleteStoreAppropriation,
    ConfirmStoreAppropriation,
    GetStoreAppropriationDetail
} from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import {
    GetUserBindSelectByPermission
} from "@/api/userApi.js";
export default {
    data() {
        return {
            title: "",
            loading: false, //是显示加载
            editFormVisible: false, //控制编辑页面显示与隐藏
            editForm: {
                keyId: "",
                storeKeyId: "",
                money: 0,
                employeeKeyId: "",
                isConfirm: false,
            },
            storeList: [],
            // rules 表单验证
            rules: {
                storeKeyId: [
                    {
                        required: true,
                        message: "请选择门店",
                        trigger: "blur",
                    },
                ],
                money: [
                    {
                        required: true,
                        message: "请输入下拨金额(元)",
                        trigger: "blur",
                    },
                    {
                        type: "number",
                        message: "请输入数字",
                        trigger: "blur",
                    },
                ],
                employeeKeyId: [
                    {
                        required: true,
                        message: "请选择员工",
                        trigger: "blur",
                    },
                ],
            },
            userList: [],
        };
    },
    computed: {},
    watch: {},
    methods: {
        //显示编辑界面
        editShow(row) {
            if (row != undefined && row != "undefined") {
                this.title = "编辑";
                let parmer = {
                    keyId: row.keyId,
                };
                GetStoreAppropriationDetail(parmer)
                    .then((res) => {
                        if (res.code == 1) {
                            this.editForm = res.data;
                            this.editFormVisible = true;
                            this.GetUserBindSelectByPermission(this.editForm.storeKeyId);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.$message.error("获取下拨金额详情失败!");
                    });
            } else {
                this.title = "新增";
                this.$data.editForm = this.$options.data.call(this).editForm;
                this.editFormVisible = true;
            }
        },
        // 编辑、增加页面保存方法
        submitForm(editData) {
            this.$refs[editData].validate((valid) => {
                if (valid) {
                    SaveStoreAppropriation(this.editForm)
                        .then((res) => {
                            if (res.code == 1) {
                                this.$parent.getListData();
                                this.$message({
                                    type: "success",
                                    message: "下拨金额保存成功！",
                                });
                                this.editFormVisible = false;
                                this.loading = false;
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            this.editFormVisible = false;
                            this.loading = false;
                            this.$message.error("下拨金额保存失败，请稍后再试！");
                        });
                } else {
                    return false;
                }
            });
        },
        // 关闭编辑、增加弹出框
        closeDialog() {
            this.editFormVisible = false;
            this.$data.editForm = this.$options.data.call(this).editForm;
        },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        if (res.code == 1) {
                            res.data.forEach((item) => {
                                this.storeList.push({
                                    keyId: item.keyId,
                                    value: item.name + '【' + item.remark2 + '】',
                                });
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        // 删除下拨金额
        deleteForm() {
            DeleteStoreAppropriation({
                keyId: this.editForm.keyId,
            })
                .then((res) => {
                    if (res.code == 1) {
                        this.$parent.getListData();
                        this.$message({
                            type: "success",
                            message: "下拨金额删除成功！",
                        });
                        this.editFormVisible = false;
                        this.loading = false;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.editFormVisible = false;
                    this.loading = false;
                    this.$message.error("下拨金额删除失败，请稍后再试！");
                });
        },
        // 确认下拨金额
        confirmForm() {
            ConfirmStoreAppropriation({
                keyId: this.editForm.keyId,
            })
                .then((res) => {
                    if (res.code == 1) {
                        this.$parent.getListData();
                        this.$message({
                            type: "success",
                            message: "下拨金额确认成功！",
                        });
                        this.editFormVisible = false;
                        this.loading = false;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.editFormVisible = false;
                    this.loading = false;
                    this.$message.error("下拨金额确认失败，请稍后再试！");
                });
        },
        // 获取人员信息绑定下拉框_根据权限
        GetUserBindSelectByPermission(storeKeyId) {
            const paramer = {
                keyId: storeKeyId,
            };
            GetUserBindSelectByPermission(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.userList = [];
                        if (res.code == 1) {
                            this.userList = res.data;
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取人员信息失败!");
                });
        },
        // 门店选择改变时触发
        handleChangeStore(val) {
            this.GetUserBindSelectByPermission(val);
        },
    },
    created() {
        this.GetOrgInfoListByConfig();
    },
    mounted() { },
    components: {},
};
</script>
<style scoped>
.wip {
    width: 200px !important;
}
</style>